import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/heu_background.jpg'


const _withScopeId = n => (_pushScopeId("data-v-2f49ad79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "start" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "backgroundImage",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "slogan-start" }, " Natürliches Wiesenheu... "),
  /*#__PURE__*/_createElementVNode("div", { class: "slogan-end" }, " ...aus dem Sauerland ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_parallax = _resolveComponent("parallax")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_parallax, { "speed-factor": _ctx.speed }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["speed-factor"]),
    _hoisted_3
  ]))
}